
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/microsoft-ai-skills-fest",
      function () {
        return require("private-next-pages/microsoft-ai-skills-fest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/microsoft-ai-skills-fest"])
      });
    }
  